document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-el-results-stats]');

  if (!sections.length) return;

  const animateNumber = (element) => {
    if (element.dataset.animated === 'true') return;

    const target = parseInt(element.dataset.target || '0', 10);
    const duration = 1400;
    const startTime = performance.now();

    element.dataset.animated = 'true';

    const updateNumber = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const eased = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.round(target * eased);

      element.textContent = `${currentValue}%`;

      if (progress < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        element.textContent = `${target}%`;
      }
    };

    requestAnimationFrame(updateNumber);
  };

  const revealSection = (section) => {
    section.classList.add('is-visible');

    const numbers = section.querySelectorAll('[data-el-stat-number]');
    numbers.forEach((number) => animateNumber(number));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealSection(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
    }
  );

  sections.forEach((section) => observer.observe(section));
});